const assignToggleButtonStickySidebar = () => {
  const button = document.querySelector(".facet-sticky-button");
  const container = document.querySelector("main");

  if (!button) return;

  const matchMedia = window.matchMedia("(max-width: 968px)");
  if (matchMedia.matches) {
    button.setAttribute("aria-controls", "facets-drawer");
    button.setAttribute("aria-expanded", "false");
  } else {
    button.addEventListener("click", () => {
      container.classList.toggle("collection-sticky-filter-active");
      button.setAttribute(
        "aria-expanded",
        container.classList.contains("collection-sticky-filter-active")
      );
    });
  }
};

async function insertSvgIntoSpan() {
  // Selecciona todos los spans con el atributo data-reference-image
  const spans = document.querySelectorAll("span[data-reference-image]");

  // Itera sobre cada span
  spans.forEach(async (span) => {
    const svgUrl = span.getAttribute("data-reference-image");

    try {
      // Obtén el contenido del SVG usando fetch
      const response = await fetch(svgUrl);

      if (response.ok) {
        const svgContent = await response.text();

        // Inserta el SVG dentro del span
        span.innerHTML = svgContent;
      } else {
        console.error(`No se pudo obtener el SVG de: ${svgUrl}`);
      }
    } catch (error) {
      console.error(`Error al obtener el SVG: ${error.message}`);
    }
  });
}

document.addEventListener("DOMContentLoaded", function () {
  assignToggleButtonStickySidebar();

  insertSvgIntoSpan();
});

class CrossColor extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      tabs: ".cross_tabs_html",
      tab: ".tab",
    };

    this.state = {
      currentTab: "PACK",
      colors: [],
      variants: [],
      currentProduct: {},
      currentOptions: {},
      currentVariant: {},
      productsBundle: [],
      optionSelected: [],
      swatchSettings: [],
      variantsSelected: [],
      unavailableColors: [],
      lowStockWarnings: [],
    };

    this.CDN_FILES = "/cdn/shop/files";

    this.variants = [];

    this.getColorJson();
    this.assignCurrentVariant();

    this.renderTabs();
    this.render();
  }

  gotoActionSingle() {
    const { handle } = this.state.productsBundle[0].product;

    window.location.href = `/products/${handle}`;
  }

  getDefaultContent() {
    return `
    <div class="group-cross">
      <div class="label">Color: <span label-cross-color></span></div>
      <cross-color></cross-color>
    </div>
    `;
  }

  getDefaultVariantContent(label) {
    const { name, content } = label;

    return `
      <div class="group-cross" id="gcross-${name}">
        <div class="label">${name}: <span label-current-variant></span></div>
        ${content}
      </div>
    `;
  }

  renderTabs() {
    return `
      <div class="tabs">
        <a href="${urlProductSingle}" class="tab cross-tab uppercase ${this.state.currentTab === "SINGLE" ? "active" : ""
      }" data-tab="SINGLE">
          <span>Single</span>
        </a>
        <button class="tab ${this.state.currentTab === "PACK" ? "active" : ""
      }" data-tab="MULTI">
          <span>Pack</span>
        </button>
      </div>
    `;
  }

  addEventListenersTabs() {
    document.querySelectorAll(".cross-tabs .tab").forEach((tab) => {
      tab.addEventListener("click", (event) => {
        this.state.currentTab = event.target.innerText;

        if (this.state.currentTab === "SINGLE") {
          this.gotoActionSingle();
        }

        this.render();
        this.addEventListeners();
      });
    });
  }

  addEventListenersPackLabel() {
    document.querySelectorAll(".color-picket-group").forEach((div) => {
      div.addEventListener("click", (event) => {
        event.stopPropagation();
        const currentVariant = event.target.htmlFor;
        if (currentVariant) {
          const formatId = currentVariant.replace("pack", "");
          this.assignCurrentVariantById(Number(formatId));
        }

        this.updatePreselectedColors();
        this.render();
        this.addEventListeners();
      });
    });

    this.querySelectorAll(".toggle-select-state").forEach((button) => {
      const parent = button.closest(".color-cross-picket-group");
      parent.addEventListener("click", (event) => {
        event.stopPropagation();

        const select = parent.querySelector(".select-color-list");

        this.querySelectorAll(".select-color-list[expanded]").forEach((el) => {
          if (el !== select) {
            el.removeAttribute("expanded");
          }
        });

        if (select.hasAttribute("expanded")) {
          select.removeAttribute("expanded");
        } else {
          select.setAttribute("expanded", "");
        }
      });
    });

    document.addEventListener("click", (event) => {
      if (!event.target.closest(".color-cross-picket-group")) {
        this.querySelectorAll(".select-color-list[expanded]").forEach((el) => {
          el.removeAttribute("expanded");
        });
      }
    });

    document
      .querySelectorAll(".select-color-list .row-color-preview")
      .forEach((div) => {
        div.addEventListener("click", (event) => {
          event.preventDefault();
          event.stopPropagation();

          const currentColor = div.getAttribute("value");
          const number = div
            .closest(".select-color-list")
            .getAttribute("data-reference");
          //this.assignCurrentVariantById(Number(formatId));

          this.state.currentOptions = {
            ...this.state.currentOptions,
            [`color${number}`]: currentColor,
          };

          this.updateImageReference(currentColor);
          this.render();
          this.addEventListeners();
        });
      });
  }

  updatePreselectedColors() {
    const numberInputsColor = Number(
      (this.state.currentVariant.title || "").replace("Pack", "") || 0
    );
    const { variantsSelected } = this.state;
    const selectedSize = this.state.currentOptions.size;
    const defaultColor = this.state.colors[0];

    if (numberInputsColor > variantsSelected.length) {
      for (let i = variantsSelected.length + 1; i <= numberInputsColor; i++) {
        const colorKey = `color${i}`;
        const selectedColor =
          this.state.currentOptions[colorKey] || defaultColor;
        const newVariant = this.state.productsBundle
          .map((product) =>
            product.product.variants.find(
              (variant) =>
                variant.option1 === selectedColor &&
                variant.option2 === selectedSize
            )
          )
          .find(Boolean);

        if (newVariant) {
          variantsSelected.push(newVariant);
        }

        this.state.currentOptions[colorKey] = selectedColor;
      }
    } else if (numberInputsColor < variantsSelected.length) {
      this.state.variantsSelected = variantsSelected.slice(
        0,
        numberInputsColor
      );
      for (let i = numberInputsColor + 1; i <= variantsSelected.length; i++) {
        delete this.state.currentOptions[`color${i}`];
      }
    }
  }

  updateImageReference(currentColor) {
    const { featured_image, name } = this.state.productsBundle
      .map((product) =>
        product.product.variants.find(
          (variant) => variant.option1 == currentColor
        )
      )
      .find((variant) => variant !== undefined);
  
    const imageNode = document.querySelector(".product-gallery__media");
    if (!featured_image?.src) return;
  
    document.querySelector("body").classList.add("image-product-replaced");
  
    const baseUrl = featured_image.src.split("?")[0];
    const srcset = [200, 300, 400, 500, 600, 700, 800, 1000, 1200, 1400, 1600, 1800, 2000, 2200, 2400]
      .map(size => `${baseUrl}?width=${size} ${size}w`)
      .join(", ");
  
    imageNode.innerHTML = `
      <img 
        src="${baseUrl}?width=2400" 
        srcset="${srcset}" 
        width="auto" 
        height="auto" 
        loading="lazy" 
        alt="Image Variant for ${name}">
    `;
  }
  
  closeSelects() {
    document.querySelectorAll(".select-color-list").forEach((div) => {
      div.classList.remove("expanded");
    });
  }

  assignCurrentVariantById(id) {
    this.state.currentVariant = this.state.currentProduct.variants.find(
      (variant) => variant.id === id
    );
  }

  getColorJson() {
    const container = document.querySelector("[data-cross-colors]");
    const dataJson = JSON.parse(container.innerHTML);

    const {
      colors_available,
      current_product,
      products_bundle,
      swatch_config,
    } = {
      ...dataJson,
    };
    this.colors = colors_available ?? [];

    const arraySwatch = new Array();

    swatch_config.forEach((config) => {
      const swatch = config.swatch_parts;

      arraySwatch.push(swatch);
    });

    this.state.swatch_config = arraySwatch;

    const colors = new Set();

    products_bundle.forEach((product) => {
      const options = product.options.find((option) => option.name === "Color");

      if (options) {
        options.values.forEach((value) => colors.add(value));
      }
    });

    const uniqueColors = Array.from(colors);

    this.state.swatchSettings;
    this.state = {
      ...this.state,
      currentProduct: current_product,
      colors: uniqueColors,
      productsBundle: products_bundle,
      swatch_config: arraySwatch,
    };
  }

  static get observedAttributes() {
    return ["variants"];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "variants") {
      try {
        this.variants = JSON.parse(newValue);
      } catch (e) {
        console.error("Invalid variants JSON", e);
      }
    }
  }

  connectedCallback() {
    this.initializeDefaultVariant();
    this.stateCTA();
    this.render();
    this.addEventListeners();
  }

  initializeDefaultVariant() {
    if (this.state.colors.length > 0) {
      const defaultColor = this.state.colors[0];
      const numberInputsColor = Number(
        (this.state.currentVariant.title || "").replace("Pack", "") || 0
      );

      this.state.currentOptions = Object.fromEntries(
        Array.from({ length: numberInputsColor }, (_, i) => [
          `color${i + 1}`,
          defaultColor,
        ])
      );
    }

    const sizes = new Set();
    this.state.productsBundle.forEach((product) => {
      const options = product.options.find((option) => option.name === "Size");
      if (options) {
        options.values.forEach((value) => sizes.add(value));
      }
    });

    const uniqueSizes = Array.from(sizes);
    if (uniqueSizes.length > 0) {
      this.state.currentOptions.size = uniqueSizes[0];
      this.updateSelectedVariants();
    }

    requestAnimationFrame(() => {
      const firstSizeInput = this.querySelector(
        `input[name="size"][value="${this.state.currentOptions.size}"]`
      );
      if (firstSizeInput) {
        firstSizeInput.checked = true;
      }
    });
  }

  updateSelectedOption(optionName, optionValue) {
    this.state.currentOptions = {
      ...this.state.currentOptions,
      [optionName]: optionValue,
    };
  }

  addEventListeners() {
    this.querySelectorAll("select").forEach((select, index) => {
      select.addEventListener("change", (event) => {
        const selectedColor = event.target.value;
        this.querySelector(`#color${index + 1}`).value = selectedColor;
        this.filterVariants(selectedColor);
      });
    });
  }

  addEventListenersInputs() {
    this.querySelectorAll("input[name='size']").forEach((input) => {
      input.addEventListener("change", (event) => {
        const selectedSize = event.target.value;
        this.updateSelectedOption("size", selectedSize);
        this.updateSelectedVariants();
        this.render();
        this.addEventListeners();
      });
    });
  }

  updateSelectedVariants() {
    const selectedSize = this.state.currentOptions.size;
    const selectedColor = this.state.currentOptions.color1;
    if (!selectedSize) return;

    this.state.variantsSelected = this.state.productsBundle
      .map((product) =>
        product.product.variants.find(
          (variant) =>
            variant.option1 === selectedColor &&
            variant.option2 === selectedSize
        )
      )
      .filter(Boolean);
  }

  filterVariants(color) {
    const availableVariants = this.variants.filter(
      (variant) => variant.color === color && variant.available
    );

    this.closeSelects();
    console.log("Available Variants: ", availableVariants);
  }

  getColorBySwatchSettings(color) {
    if (!this.state.swatch_config || !Array.isArray(this.state.swatch_config)) {
      return null;
    }

    return this.state.swatch_config.find((swatch) => {
      if (!swatch || !swatch[0]) return false;

      const label = swatch[0].trim();

      return label === color;
    });
  }

  getColorReference(index) {
    const colorOption = this.state.currentOptions[`color${index + 1}`];
    const colorBySwatchSettings = this.getColorBySwatchSettings(colorOption);

    if (!colorBySwatchSettings) {
      return { type: "hex", value: "#000000" };
    }

    const isHexa = colorBySwatchSettings[1].startsWith("#");

    return {
      type: isHexa ? "hex" : "image",
      value: isHexa
        ? colorBySwatchSettings[1]
        : `${this.CDN_FILES}/${colorBySwatchSettings[1]}`,
    };
  }

  getLabelFromOption(i) {
    const label = `color${i + 1}`;
    return this.state.currentOptions[label] || "Select";
  }

  getLabelorImageWithColor(color) {
    const colorBySwatchSettings = this.getColorBySwatchSettings(color);
    if (!colorBySwatchSettings) {
      return color;
    }

    return colorBySwatchSettings[1].startsWith("#")
      ? `<div class="box-swatch-preview" style="background-color: ${colorBySwatchSettings[1]}"></div>`
      : `<img class="box-swatch-preview" src="${this.CDN_FILES}/${colorBySwatchSettings[1]}" alt="${color}" />`;
  }

  renderCrossColorInputs() {
    const numberInputsColor = Number(
      (this.state.currentVariant.title || "").replace("Pack", "") || 0
    );

    return `
      ${Array.from({ length: numberInputsColor }, (_, i) => {
      const colorRef = this.getColorReference(i);
      const isSingleColor = this.state.colors.length === 1;

      const htmlMultipleColor = !isSingleColor
        ? `              <button class="toggle-select-state">
                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="7" viewBox="0 0 10 7" fill="none">
                  <path d="M9 1L5 5L1 1" stroke="#1D1D1D" stroke-width="2" stroke-linecap="round"/>
                </svg>
              </button>
              <div class="select-color-list" data-reference="${i + 1
        }" id="select${i + 1}">
                ${this.state.colors
          .map((color) => {
            const colorRef = this.getLabelorImageWithColor(color);
            return `
                      <div class="flex flex-row row-color-preview" value="${color}">
                        <div class="swatch-value">${colorRef}</div>
                        <div class="swatch-label">${color}</div>
                      </div>
                    `;
          })
          .join("")}
              </div>`
        : ``;

      return `
          <div class="cross-color-picker">
            <label for="color${i + 1}">${this.getLabelFromOption(i)}</label>
            <div class="color-cross-picket-group ${isSingleColor ? "single-color" : ""}">
              ${colorRef.type === "hex"
          ? `
                <input type="color" name="color" id="color${i + 1}" value="${colorRef.value
          }" disabled />
              `
          : `
                <div class="color-preview" style="background-image: url('${colorRef.value}');"></div>
              `
        }
              ${htmlMultipleColor}
            </div>
          </div>
          `;
    }).join("")}
    `;
  }

  renderContentVariantByPacks() {
    const product = this.state.currentProduct;
    const currentVariant = this.state.currentVariant;
    const label = product.options[0];

    const isSingleColor = this.state.colors.length === 1;
    console.log("isSingleColor: ", isSingleColor, this.state.colors, this.state);
    const firstColor = this.state.colors[0];

    return `
      <div class="content--tab__pack flex flex-row">
        <div class="option-title">
          <span>${label}</span>
        </div>
        ${product.variants
        .map(
          (variant) => `
              <div class="pack-color-selector"> 
                <div class="color-picket-group ${variant.id == currentVariant.id ? "active" : ""
            }">
                  <input type="hidden" data-variant-id=${variant.id} id="pack${variant.id
            }" value="${variant.title}" />
                  <label for="pack${variant.id}">${variant.title}</label>
                </div>
              </div>
            `
        )
        .join("")}
      </div>

      <div class="content--tab__cross-wrapper">
        <div class="option-title">
          <span>Color: ${firstColor}</span>
        </div>
        ${!isSingleColor ? this.renderCrossColorInputs() : ''}
      </div>
    `;
  }

  assignCurrentVariant() {
    this.state.currentVariant = this.state.currentProduct.variants[0];
  }

  renderContent() {
    const defaultContent = `
      <div class="content--tab__cross"></div>
    `;

    return this.state.currentTab === "SINGLE"
      ? defaultContent
      : this.renderContentVariantByPacks();
  }

  stateCTA() {
    const buttons = document.querySelector("buy-buttons");
    !!buttons && buttons.classList.add("hidden");
  }

  checkProductsAvailable() {
    const { size, ...colors } = this.state.currentOptions;
    const currentProductID = this.state.currentProduct.id;
    const selectedVariants = [];
    const unavailableColors = [];
    const lowStockWarnings = [];

    this.state.productsBundle.forEach((product) => {
      if (product.product.id === currentProductID) {
        return;
      }
      Object.values(colors).forEach((color) => {
        const variant = product.product.variants.find(
          (variant) => variant.option1 == color && variant.option2 === size
        );

        //error state messages
        if (variant) {
          selectedVariants.push(variant);
          if (!variant.available) {
            unavailableColors.push(`${color} / ${size}`);
          }
          if (variant.stock < 5) {
            lowStockWarnings.push(
              `Only ${variant.stock} pcs are available from ${color} / ${size}`
            );
          }
        } else if (size) {
          unavailableColors.push(`${color} / ${size}`);
        }
      });
    });

    this.state = {
      ...this.state,
      variantsSelected: selectedVariants,
      unavailableColors,
      lowStockWarnings,
    };
  }

  renderCTA() {
    this.checkProductsAvailable();
    const label = "Add to cart";
    /*
    const numberInputsColor = Number(
      (this.state.currentVariant.title || "").replace("Pack", "") || 0
    );
    const selectedColorsCount = new Set(
      this.state.variantsSelected.map((variant) => variant.option1)
    ).size;
    const isAvailable =
      this.state?.variantsSelected?.length > 0 &&
      selectedColorsCount === numberInputsColor
        ? ""
        : "disabled";
    */
    const isAvailable =
      this.state?.variantsSelected.length > 0 ? "" : "disabled";
    const allVariantsAvailable = this.state.variantsSelected.every(
      (variant) => variant.available
    );

    const unavailableText = !allVariantsAvailable
      ? `<div class="unavailable">Not available: ${this.state?.unavailableColors?.join(
        ", "
      )}</div>`
      : "";
    const lowStockText =
      this.state.lowStockWarnings?.length > 0
        ? `<div class="low-stock">${this.state.lowStockWarnings?.join(
          "<br>"
        )}</div>`
        : "";

    return `
      <div class="cta">
        <button class="button primary-black cta__button cta_button_cross ${isAvailable}">${label}</button>
        ${unavailableText}
        ${lowStockText}
      </div>
    `;
  }

  async addVariants() {
    const items = this.state.variantsSelected.map((variant) => ({
      id: variant.id,
      quantity: 1,
    }));

    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          items,
          sections:
            "cart-count, variant-added, sections--17218834694186__cart-drawer",
        }),
      });

      if (!response.ok) {
        throw new Error("Error al agregar productos al carrito");
      }

      const data = await response.json();
      const cart = await fetch("/cart.js", {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      });
      const cart_data = await cart.json();

      document.dispatchEvent(
        new CustomEvent("cart:change", {
          bubbles: true,
          detail: {
            baseEvent: "line-item:change",
            cart: cart_data,
          },
        })
      );

      document.documentElement.dispatchEvent(
        new CustomEvent("cart:refresh", {
          bubbles: true,
          detail: {
            baseEvent: "variant:add",
            cart: cart_data,
          },
        })
      );

      document.querySelector('[aria-controls="cart-drawer"]').click();
      return data;
    } catch (error) {
      console.error("Error:", error);
    }
  }

  formatMoney(cents, currency = "$") {
    return currency + (cents / 100).toFixed(2);
  }

  updateTotalPrice() {
    const html = document.querySelector(".product-info .product-info__price");
    const html_responsive = document.querySelector(".mobile-product-info .product-info__price");

    // Validar que los elementos existan
    if (!html || !html_responsive) {
      console.warn("No se encontraron los elementos de precio en el DOM.");
      return;
    }

    const variant = this.state.currentVariant;

    if (!variant) {
      console.warn("No se encontró la variante actual.");
      return;
    }

    const totalPrice = parseFloat(variant.price) || 0;
    const comparePrice = parseFloat(variant.compare_at_price) || 0;

    console.log("Precio actual:", totalPrice);
    console.log("Precio de comparación:", comparePrice);

    const content = `
    <span class="pdp-price ${comparePrice > 0 ? "line-through" : ""}">
      ${this.formatMoney(comparePrice)}
    </span>
    ${totalPrice > 0
        ? `<span class="pdp-compare-price text-on-sale">${this.formatMoney(totalPrice)}</span>`
        : ""
      }
  `;

    const contentEmpty = `
    <span class="pdp-compare-price">${this.formatMoney(totalPrice)}</span>
  `;

    html.innerHTML = comparePrice > 0 ? content : contentEmpty;
    html_responsive.innerHTML = comparePrice > 0 ? content : contentEmpty;
  }


  assignEventSubmit() {
    this.querySelector(".cta_button_cross").addEventListener("click", () => {
      this.addVariants();
    });
  }

  renderContentBySize() {
    const sizes = new Set();

    this.state.productsBundle.forEach((product) => {
      const options = product.options.find((option) => option.name === "Size");

      if (options) {
        options.values.forEach((value) => sizes.add(value));
      }
    });

    const uniqueSizes = Array.from(sizes);
    const currentSize = this.state.currentOptions["size"];

    return `
      <div class="content--tab__size">
        <div class="option-title">
          <span>Size</span>
        </div>
        ${uniqueSizes
        .map(
          (size) => `
              <div class="size-selector">
                <input type="radio" name="size" id="size-${size}" value="${size}" ${currentSize === size ? "checked" : ""
            } />

                <label class="size-label-wrapper ${currentSize === size ? "active" : ""
            }" for="size-${size}">${size}</label>
              </div>
            `
        )
        .join("")}
      </div>
    `;
  }

  render() {
    this.innerHTML = `
     <div class="cross_tabs__wrapper">
        ${this.renderTabs()}
        ${this.renderContent()}
        ${this.renderContentBySize()}
        ${this.renderCTA()}
      </div>
    `;

    this.addEventListenersTabs();
    this.addEventListenersPackLabel();
    this.addEventListenersInputs();
    this.assignEventSubmit();
    this.updateTotalPrice();
  }
}

customElements.define("cross-color", CrossColor);

document.addEventListener("DOMContentLoaded", function () {
  const galleryWrapper = document.querySelector(".product-gallery");
  function applyMinHeight() {
      if (!galleryWrapper) return;
      if (window.innerWidth < 640) {
          galleryWrapper.style.minHeight = galleryWrapper.offsetHeight + "px";
      } else {
          galleryWrapper.style.minHeight = "";
          window.removeEventListener("resize", applyMinHeight);
      }
  }
  function handleResize() {
      if (window.innerWidth < 640) {
          applyMinHeight();
      } else {
          galleryWrapper.style.minHeight = "";
          window.removeEventListener("resize", handleResize);
      }
  }
  // Apply only if width is below 640px initially
  if (window.innerWidth < 640) {
      applyMinHeight();
      window.addEventListener("resize", handleResize);
  }
});

class CartUpdater {
  constructor() {
    this.sectionId = 'template--17697534574634__main';
    this.init();
  }

  init() {
    const items = document.querySelectorAll('.action-change-cart');
    items.forEach(item => this.attachEvents(item));
  }

  attachEvents(item) {
    const decreaseBtn = item.querySelector('.quantity-decrease');
    const increaseBtn = item.querySelector('.quantity-increase');
    const input = item.querySelector('.quantity-input');
    const removeLink = item.querySelector('.remove-btn a');
    const lineItemData = JSON.parse(item.querySelector('.line-item-data')?.textContent || '{}');

    if (decreaseBtn) {
      decreaseBtn.addEventListener('click', () => {
        this.updateQuantity(lineItemData, parseInt(input.value) - 1);
      });
    }

    if (increaseBtn) {
      increaseBtn.addEventListener('click', () => {
        this.updateQuantity(lineItemData, parseInt(input.value) + 1);
      });
    }

    if (removeLink) {
      removeLink.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.removeItem(lineItemData);
      });
    }
  }

  updateQuantity(lineItemData, newQuantity) {
    const formData = {
      id: lineItemData.key,
      quantity: newQuantity
    };

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData)
    })
      .then(res => res.json())
      .then(() => this.refreshSection());
  }

  removeItem(lineItemData) {
    const updates = {
      [lineItemData.key]: 0
    };

    fetch(`${window.Shopify.routes.root}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates })
    })
      .then(res => res.json())
      .then(() => this.refreshSection());
  }

  refreshSection() {
    fetch(`${window.Shopify.routes.root}?sections=${this.sectionId}`)
      .then(res => res.json())
      .then(data => {
        const newHtml = data[this.sectionId];
        const container = document.getElementById(`shopify-section-${this.sectionId}`);
        if (container) {
          const temp = document.createElement('div');
          temp.innerHTML = newHtml;
          const newSection = temp.firstElementChild;
          container.replaceWith(newSection);
          this.init(); // Reasigna eventos
        }
      });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new CartUpdater();
});
